import { useRouter } from '@application/utils';
import { TeamPage } from '@presentation/pages';
import { useTranslation } from '@presentation/utils';
import { SeoController } from '../../SeoController';

export const TeamPageController = () => {
  const { routeLocationDescriptor } = useRouter();
  const { translate } = useTranslation();

  return (
    <>
      <SeoController
        title={translate('team.seo.title')}
        description={translate('team.seo.description')}
      />
      <TeamPage joinTeamLink={routeLocationDescriptor('contact')} />;
    </>
  );
};
